<template>
  <div class="card__wrap">
    <div v-if="simcard" class="card" >
      <div class="header-profile">
        <div class="icons">
          <sis-icon-status class="icon_status" :status="+simcard.active" :title="(+simcard.active)? translate('filter.status.online') : translate('filter.status.offline')"/>
          <h4 class="title">
            {{this.get_online_status()}}
          </h4>
        </div>

        <div class="linked-cards">
          <div class="linked-card__wrap" v-for="(link, key) in links" :key="key">
            <LinkedSimCard
              v-if="link != null"
              :title="key"
              :simcard="link"
            />
          </div>
        </div>
      </div>

      <div class="device_list">
        <DeviceHistory
          :title="translate('simcard_devices.section.device_history')"
          :profile="profile"
        />
      </div>

      <div class="content">
        <form class="simcard-profile">

          <div class="row">

            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.number"
                type="text"
                :label="translate('simcard_devices.number')"
                :placeholder="translate('simcard_devices.number')"
                :readonly="editNumber"
              />
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.imsi"
                type="text"
                label="imsi"
                :readonly="true"
                placeholder="imsi"
              />
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.iccid"
                type="text"
                label="iccid"
                :readonly="true"
                placeholder="iccid"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-sm-6">
              <fg-input
                v-model="simcard.operator"
                type="text"
                :label="translate('simcard_devices.operator')"
                :placeholder="translate('simcard_devices.operator')"
                :readonly="editOperator"
              />
            </div>
            <div class="col-md-8 col-sm-6">
              <fg-input
                v-model="simcard.tariff"
                type="text"
                :label="translate('simcard_devices.tariff')"
                :placeholder="translate('simcard_devices.tariff')"
                :readonly="true"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">

            <div class="col-md-12 col-sm-12">
              <sis-select
                v-model="simcard.group_id"
                :options="opt_groups"
                :placeholder="translate('groups')"
                :label="translate('group.one')"
                track-by="name"
                :clearable="false"
                :noresult="translate('group.not_found')"
                :disabled="!access"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12">
              <fg-input
                v-model="simcard.custom_sim_name"
                type="text"
                :label="translate('simcard_devices.custom_name')"
                :placeholder="translate('simcard_devices.custom_name')"
                :readonly="!access"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ translate('simcard_devices.description') }}</label>
                <textarea
                  v-model="simcard.description"
                  rows="5"
                  class="form-control border-input"
                  :placeholder="translate('simcard_devices.description')"
                  :readonly="!access"
                />
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="text-center">
                <span
                  type="submit"
                  class="btn btn-success btn-wd"
                  @click.prevent="saveUpdateProfile()"
                >
                  {{ translate('save') }}
                </span>
              </div>
            </div>
          </div>

          <div class="clearfix" />
        </form>
      </div>
    </div>


    <div class="history_action__wrap">
      <Summary
        type="simcard_devices"
        :info="simcard"
      />
    </div>
  </div>

</template>
<script>

import SisSelect from 'components/UIComponents/Inputs/SisSelect.vue'
import SisIconStatus from 'components/UIComponents/Icon/SisIconStatus.vue'
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";
import Summary from '../../General/Summary.vue'
import DeviceHistory from './DeviceHistory'
import LinkedSimCard from 'components/UIComponents/Icon/LinkedSimCard.vue'

export default {
  components: {
    SisSelect,
    SisIconStatus,
    Summary,
    DeviceHistory,
    LinkedSimCard
  },

  props: {
    profile: {
      type: [Array, Object],
      default: () => []
    }
  },

  created() {
    this.update_sim()
    this.check_links(this.simcard)
  },
  data () {
    return {
      ch_group: false,
      showBlock: true,
      simcard: {
        type: [Array, Object],
        default: () => []
      },
      editNumber: true,
      editOperator: true,
      links: {}
    }
  },

  computed: {
    simcard_id (){
      return this.simcard.id
    },
    access () {
      return this.$store.getters.getPermissions.permissionGod
    },
    opt_groups () {
      return this.$store.getters.getSimcardDevicesGroupsTree
    },
    balance_trafic(){
      if (!this.simcard.traffic) return null

      let trafic_GB = +this.simcard.traffic.balance_value / 1024
      if (trafic_GB > 5) {
        return {trafic: Math.round(trafic_GB) + ' GB', color: 'black'}
      }else if (trafic_GB > 1) {
        return {trafic: Math.round(trafic_GB) + ' GB', color: 'orange'}
      }
      return {trafic: this.simcard.traffic.balance_value + ' MB', color: 'red'}
    },
    last_update(){
      let ts = new Date().getTime()/1000
      var duration = parseInt(ts - this.simcard.traffic.ts_update);
      let minutes = 0
      let hours = parseInt((duration/(60*60)));
      if (hours < 5) {
        minutes = parseInt((duration/60));
        return minutes + " " + this.translate('simcard_devices.min_ago')
      }
      minutes = parseInt((duration/60)%60);
      return hours + " " + this.translate('simcard_devices.h_ago')
    },
  },

  watch : {
    profile: {
      deep: true,
      handler () {
        this.change = !this.init
        this.$emit('change', this.change)
        this.init = false
        this.update_sim()
        this.check_links(this.simcard)
      }
    }
  },

  methods: {
    get_online_status(){
       if(this.profile.active < 1){
         if(this.profile.ts_sync === 0) {
           return this.translate('device.off_forever');
         }
         return this.translate('device.off_since') + ' ' + this.get_date(this.profile.ts_sync);
       }else if (this.profile.active > 0){
         return this.translate('device.on_since') + ' ' + this.get_date(this.profile.ts_sync);
       }
       return '';
    },
    check_links (sim) {
      let msisdn = sim.msisdn ? sim.msisdn : sim.number
      this.$http.simcard.getAllSimcards(msisdn, sim.iccid, sim.imsi, (response) => {
        let links = response.data
        for (let index in links) {
          if (index === 'status' || index === 'device_simcard') {
            delete(links[index])
          }
        }
        this.links = links
        },
        (bad_answer) => {
          this.bad_answer_handler(bad_answer)
        }
      )
    },
    update_sim(){
      this.simcard = {...this.profile}
      !this.simcard.number ? this.editNumber = false : this.editNumber = true
      !this.simcard.operator ? this.editOperator = false : this.editOperator = true
    },

    saveUpdateProfile () {
      var t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('ask_save')
        },
        on: {
          close: () => {
            this.$modal.hide('put_simcard_device')
          },
          confirm: () => {
            this.updateSimcard()
            this.$modal.hide('put_simcard_device')
          }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'put_simcard_device'})
    },

    updateSimcard(){
      let simcard = this.simcard
      delete(simcard.id)
      this.$http.v1.putSimcardDevices(this.simcard.imsi, {...simcard}, () => {
        this.global_notify('info', this.translate('profile_saved'))
        this.$store.dispatch('updateSimcardDevicesProfile', this.simcard.imsi)
      })
    },

    cancel () {
      this.init = true
      this.simcard = {...this.profile}
    },
  }
}

</script>

<style lang='scss' scoped>
  .card{
    padding-left: 0;
    padding-right: 0;
    width: 64.5%;
    &__wrap{
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .header-profile {
      padding: 10px 8px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &.blocked{
        border: 2px solid #EB5E28;
        .simcard_blocked{
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          width: 10%;
          min-width: 150px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #EB5E28;
          color: white;
          font-size: 12px;
        }
      }
      .linked-cards{
        height: 90px;
        display: flex;
        cursor: pointer;
        .linked-card__wrap{
          height: 100%;
          margin-right: 5px;
          &:last-child{
            margin-right: 0;
          }
        }
      }

      .icons{
        display: flex;
        justify-content: center;
        align-items: center;
        .icon_status{
          margin: 0 5px 3px 0;
        }
      }
    }
    .button_div {
      padding-bottom: 10px;
      padding-top: 5px;
    }

    .version {
      font-size: 10px;
      color: #9A9A9A;
    }

    .table_ip_tr {
      background-color: #eee !important;
    }
  }

  .history_action__wrap{
    width: 34.5%;
    height: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    background-color: #f8f8f8;
  }

  @media (max-width:1350px){
    .card{
      width: 100%;
      height: auto;
      min-height: inherit;
      margin-bottom: 10px;
      &__wrap{
        height: auto;
        flex-direction: column;
        padding-bottom: 10px;
      }
    }
    .history_action__wrap{
      width: 100%;
      height: auto;
    }
  }


  @media (max-width:767px){
    .card{
      .header-profile {
        &.blocked{
          .simcard_blocked{
            position: inherit;
            height: 100%;
            width: calc(100% + 16px);
            margin: 10px 0px -10px -8px;
            padding: 5px;
            min-width: inherit;
          }
        }
      }
    }
  }

  @media (max-width:550px){
    .card{
      .header-profile {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
      }
    }
  }
</style>
